import { Box } from '@mui/material';
import Model from '../models/model';

const model = new Model({
	name: 'EndoScopeCode',
	title: 'Barcode',
	disableExport: true,
	disableColumnSelector: true,
	pathname: '/barcode',
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true,
	},
	disableDelete: true,
	columns: [
		{ header: 'Barcode', field: 'BarCode', width: 200, required: true },
		{ header: 'Active', field: 'IsActive', type: 'bool', width: 80, required: true },
		{ header: 'EndoScopeId', field: 'EndoScopeId', excludeOnGrid: true, hideLabel: true, customizeInput: () => <Box /> },
	]
});
export const BarcodeModel = model;
export default model.createFormBase();